<template>
<div>
  <template v-if="showFilter">
   <pt-page-search @search="search" @emptySearch="emptySearch" :isAddrouter="false" :class="$style['select-form-user-search']" :searchKey="searchKey"></pt-page-search>
    <pt-page-factor-filter :labels="filterFactor" v-model="params">
        <el-button type="primary" plain @click="cutOrder" v-if="!isFilterOrder">切换至下单筛选</el-button>
        <el-button type="primary" plain @click="cutCustomer" v-if="isFilterOrder">切换至用户信息筛选</el-button>
        <el-button type="primary" @click="Filter">筛选</el-button>
    </pt-page-factor-filter>
  </template>
     <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber" :page-size="pageSize" :class="$style['table-data-user']"
        :pager-count="5" :refresh="false" ref="table">
            <wt-table :list="tableData" :labels="tableLabels">
                <el-table-column label="操作" v-if="pageEdit" :min-width="100">
                    <template slot-scope="scope">
                        <el-button type="text" @click="detail(scope.row)">详情</el-button>
                        <el-button v-if="showFilter" type="text" @click="deleteUser(scope.row,scope.$index)">移除</el-button>
                    </template>
                </el-table-column>
            </wt-table>
     </wt-paged-table>
</div>
</template>
<script>
import { couponUserListLabels, filterFactorUser, filterFactorUserOrder, filterFactorUserPromotion, companyUser, cityForUser, importCustomerLabel } from './pt-all-customer/all-customer-option'
import { emptyObject } from '@/utils/lifebankUtils'
export default {
  props: {
    userIds: {
      type: Array,
      default: function () {
        return []
      }
    },
    pageEdit: {
      type: Boolean,
      default: false
    },
    // 查询user——list的时候，传入的参数名称
    parameter: {
      type: String,
      default: 'ids'
    },
    // 根据接口所传参数删除时对比的字段
    filed: {
      type: String,
      default: 'id'
    },
    fromPage: {
      type: String,
      default: null
    },
    // 是否查看导入用户
    isImport: {
      type: Boolean,
      default: false
    },
    userListId: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      tableLabels: this.isImport ? importCustomerLabel : couponUserListLabels,
      filterFactor: this.fromPage === 'promotion-form' ? filterFactorUserPromotion : filterFactorUser,
      params: {},
      paramsData: {},
      totalNumber: 0,
      pageSize: 6,
      tableData: [],
      allCitys: [],
      isFilterOrder: false,
      searchKey: null,
      branchCompanys: []
    }
  },
  watch: {
    'params.role' (val) {
      let hasComay = false
      let hasCity = false
      if (val && (val === 'COUNSELOR_USER' || val === 'DOCTOR_USER')) {
        this.filterFactor.forEach((item, index) => {
          if (item.value === 'branchCompanyId') {
            hasComay = true
          }
          if (item.value === 'city') {
            this.filterFactor.splice(index, 1)
            this.$set(this.params, 'city', null)
          }
        })
        if (!hasComay) {
          this.filterFactor.splice(1, 0, companyUser)
          this.getFilterLabelsOptions(this.branchCompanys, 'branchCompanyId')
        }
      } else {
        this.filterFactor.forEach((item, index) => {
          if (item.value === 'branchCompanyId') {
            this.filterFactor.splice(index, 1)
            this.$set(this.params, 'branchCompanyId', null)
          }
          if (item.value === 'city') {
            hasCity = true
          }
        })
        if (!hasCity) {
          this.filterFactor.splice(2, 0, cityForUser)
          this.getFilterLabelsOptions(this.allCitys, 'city')
        }
      }
    }
  },
  computed: {
    // 是否显示筛选条件
    showFilter () {
      return !this.isImport
    }
  },
  methods: {
    detail (val) {
      let id = this.isImport ? val.mallUserId : val.id
      this.$router.push('/all-customer/customer-detail/' + id)
    },
    search (val) {
      this.searchKey = val
      emptyObject(this.paramsData)
      emptyObject(this.params)
      this.$set(this.paramsData, 'searchKey', val)
      this.getTableData(0)
    },
    emptySearch () {
      this.$delete(this.paramsData, 'searchKey')
    },
    cutOrder () {
      this.isFilterOrder = true
      this.filterFactor = filterFactorUserOrder
    },
    cutCustomer () {
      this.isFilterOrder = false
      this.filterFactor = this.fromPage === 'promotion-form' ? filterFactorUserPromotion : filterFactorUser
    },
    // 给筛选选项赋值
    getFilterLabelsOptions (val, name) {
      this.filterFactor.forEach(item => {
        if (item.value === name) {
          item.options = val
        }
      })
    },
    getAllCity () {
      this.$store.dispatch('getAllCity').then(res => {
        this.allCitys = res
        this.getFilterLabelsOptions(res, 'city')
      }).catch(err => {
        this.$message.error(err || '获取地区列表失败')
      })
    },
    // 获取分公司列表
    getBranchCompanyList () {
      let data = {
        pageableParam: {
          unpaged: true
        },
        type: 'BRANCH'
      }
      this.$store.dispatch('getBranchCompanyList', data).then(res => {
        this.branchCompanys = res.data
        this.getFilterLabelsOptions(res.data, 'branchCompanyId')
      }).catch(err => {
        this.$message.error(err || '获取分子公司列表失败')
      })
    },
    deleteUser (row, index) {
      this.tableData.splice(index, 1)
      let userIds = JSON.parse(JSON.stringify(this.userIds))
      userIds.forEach((item, index) => {
        if (item === row[this.filed]) {
          userIds.splice(index, 1)
        }
      })
      this.$emit('viewUserListDelete', userIds, this.tableData)
    },
    Filter () {
      this.paramsData = { ...this.params }
      if (this.isFilterOrder) {
        for (var keyParams in this.paramsData) {
          filterFactorUser.forEach(item => {
            if (item.value === keyParams) {
              this.$delete(this.paramsData, keyParams)
            }
          })
        }
      } else {
        this.$delete(this.paramsData, 'mallOrder')
      }
      if (!this.isFilterOrder && this.params.age) {
        if (this.params.age.indexOf('-') > -1) {
          this.paramsData.ageStart = Number(this.params.age.split('-')[0])
          this.paramsData.ageEnd = Number(this.params.age.split('-')[1])
        } else if (this.params.age.indexOf('>') > -1) {
          this.paramsData.ageStart = Number(this.params.age.split('>')[1])
        }
        this.$delete(this.paramsData, 'age')
      }
      if (!this.isFilterOrder && this.params.loginTime) {
        this.paramsData = { ...this.params.loginTime, ...this.paramsData }
        this.$delete(this.paramsData, 'loginTime')
        this.$delete(this.params, 'index')
        this.$delete(this.paramsData, 'index')
        if (this.paramsData.age) {
          this.$delete(this.paramsData, 'age')
        }
      }
      if (this.isFilterOrder && this.params.goodsName) {
        this.paramsData.mallOrder = this.paramsData.mallOrder || {}
        this.paramsData.mallOrder.goodsName = this.params.goodsName
        this.$delete(this.paramsData, 'goodsName')
      }
      if (this.isFilterOrder && this.paramsData.mallOrder && this.paramsData.mallOrder.index) {
        let mallOrder = this.paramsData.mallOrder
        this.$delete(mallOrder, 'index')
      }
      if (this.paramsData.mallOrder && (this.paramsData.mallOrder.paidTimeStart || this.paramsData.mallOrder.paidTimeEnd)) {
        this.paramsData.mallOrder.paidTimeSort = 'ASC'
      }
      for (let key in this.paramsData) {
        if (!this.paramsData[key]) {
          this.$delete(this.paramsData, key)
        }
      }
      //   this.getTableData(0)
      this.$refs.table.resetPage()
    },
    getTableData (page, next) {
      if (this.isImport) {
        this.importedCustomer(page, next)
      } else {
        this.getUserList(page, next)
      }
    },
    getUserList (page, next) {
      // 请求用户的参数变更，请通知淞耀（促销活动弹框）
      let data = {
        pageable: {
          page: page,
          size: this.pageSize,
          sort: 'lastLoginTime,desc'
        },
        ...this.paramsData
        // ids: this.userIds
      }
      data[this.parameter] = this.userIds
      this.$store.dispatch('getMallUser', data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        }
      }).catch(err => {
        this.$refs.table.showReTry()
        this.$message.error(err || '获取用户列表失败')
      })
    },
    //
    importedCustomer (page, next) {
      let data = {
        pageable: {
          page: page,
          size: this.pageSize,
          sort: 'lastLoginTime,desc'
        },
        userListId: this.userListId
      }
      this.$store.dispatch('importedCustomer', data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        }
      }).catch(err => {
        this.$refs.table.showReTry()
        this.$message.error(err || '获取导入用户列表失败')
      })
    }
  },
  created () {
    this.getAllCity()
    this.getBranchCompanyList()
  }
}
</script>
<style module lang="less">
.select-form-user-search{
    max-width: 500Px;
    margin-bottom: 30px;
}
.table-data-user{
    :global
    .el-button{
        margin-left: 0;
        margin-right: 10px;
    }
    :global
    thead{
        width: 100%
    }
}
</style>
